import { useRef } from 'react';
import Fab from '@material-ui/core/Fab';
import ArchiveIcon from '@material-ui/icons/Archive';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import { useLocation } from 'umi';
import { download } from '@/utils/downloadUtil';
import ActionButtonGroupStyled from './ActionButtonGroupStyled';

const ActionBtnGroup = ({ handUpLoad }) => {
  const location = useLocation();
  const downloadRef = useRef();
  const { query } = location;
  // 结构到所有查询条件，包括分页条件
  const {
    orderNo,
    status,
    giftReceiveMethod,
    exchangeBeginDateTime,
    exchangeEndDateTime,
    giftType,
    shelfId,
    mobile,
    memberCode,
    giftTitle,
  } = query;
  //跳转到新增礼品
  const handleDown = () => {
    const formDta = {
      orderNo,
      giftTitle,
      status,
      giftReceiveMethod,
      exchangeBeginDateTime: exchangeBeginDateTime
        ? `${exchangeBeginDateTime} 00:00:00`
        : null,
      exchangeEndDateTime: exchangeEndDateTime
        ? `${exchangeEndDateTime} 23:59:59`
        : null,
      giftType,
      shelfId,
      mobile,
      memberCode,
    };
    window.NE_DAWN.trigger(downloadRef.current, {
      event: '_ec', // 事件名
      params: { ...formDta }, // 事件公参
    });
    download('/activityPoints/exportOrderData', formDta, '订单明细');
  };

  return (
    <ActionButtonGroupStyled>
      <div className="export-wrapper">
        <Fab
          data-log={JSON.stringify({
            oid: 'btn_point_mall_exchange_record_list_download',
            events: ['_ev'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
          })}
          ref={downloadRef}
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          sx={{ marginRight: '16px' }}
          onClick={() => handleDown()}
        >
          <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
          下载
        </Fab>
        <Fab
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="upload"
          onClick={handUpLoad}
        >
          <CreateNewFolderIcon
            sx={{ width: '24px', height: '24px', marginRight: '8px' }}
          />
          上传快递单号
        </Fab>
      </div>
    </ActionButtonGroupStyled>
  );
};
export default ActionBtnGroup;
